
// import React, { useState } from 'react';
// import {
//   AppBar,
//   Toolbar,           
//   Typography,
//   Button,
//   Box,
//   Container,
//   Grid,styled,CardMedia,
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import video1 from "./assests/video1.mp4"
// import video2 from "./assests/video2.mp4"
// import nature from './assests/nature.mp4'
// import animal from './assests/animal.mp4'
// import car from './assests/car.mp4'
// import nature1 from './assests/nature1.jpg';
// import nature2 from './assests/nature2.jpg';
// import nature3 from './assests/nature3.jpg';
// import nature4 from './assests/nature4.jpg';
// import animal1 from './assests/animal1.jpg';
// import animal2 from './assests/animal2.jpg';
// import animal3 from './assests/animal3.jpg';
// import animal4 from './assests/animal4.jpg';
// import car1 from './assests/car1.jpg';
// import car2 from './assests/car2.jpg';
// import car3 from './assests/car3.jpg';
// import car4 from './assests/car4.jpg';

// const videoSources = [
//  nature,car,animal,video1,video2
// ];


// const mediaGroups = [

//   {
//     images: [nature1, nature2,nature3, nature4],
//     video: nature,
//   },
//   {
//     images: [animal1, animal2,animal3, animal4],
//     video: animal,
//   },
//   {
//     images: [car1, car2,car3, car4],
//     video: car,
//   },
// ];
// const getGridItemProps = (total) => {
//   if (total === 1) return { xs: 12, height: '100%' };
//   if (total === 2) return { xs: 6, height: '100%' };
//   if (total === 3 || total === 4) return { xs: 6, height: '150px' };
//   return { xs: 4, height: '100px' }; // for 5 or more
// };
// const steps = [
//   {
//     title: 'Step 1',
//     heading:'Sign Up or Log In ',
//     desc: 'Create your free Vimoir account (or log in if you already have one) to access your dashboard and keep your videos secure.',
//   },
//   {
//     title: 'Step 2',
//     heading:'Upload Media & Create an Event ',
//     desc: 'To create your event, begin by selecting "Create New Event" and providing key details such as the event name, date, and description. Next, upload your photos. Once confirmed, the system automatically processes your content, generating a video and assigning it a unique, secure QR code. This end-to-end creation ensures your event is ready to share in moments, with no technical expertise required.',
//   },
//   {
//     title: 'Step 3',
//     heading:'Share Your Video securely',
//     desc: 'After creation, share your event effortlessly via email, SMS. Each event remains private—accessible only through your shared link or scanned QR code—with encrypted access to prevent unauthorized viewing. Recipients can instantly watch the video without logins or downloads, while you retain full control over the content.This streamlined approach combines elegant presentation with robust privacy protections, ideal for both personal and professional use.',
//   },
// ];


  



//   const sampleMedia = Array.from({ length: 9 }, (_, i) => {
//     const isVideo = i % 2 === 0;
//     const videoIndex = Math.floor(Math.random() * videoSources.length);
//     return {
//       type: isVideo ? 'video' : 'image',
//       src: isVideo
//         ? videoSources[videoIndex]
//         : `https://picsum.photos/400/300?random=${i}`,
//     };
//   });
  
// const WelcomePage = () => {
//     const navigate = useNavigate();

//     const [hoveredIndex, setHoveredIndex] = useState(null);
//     const handleSignIn = () => {
//         console.log('Sign In clicked');
//         navigate('/login'); 
//       };
      
//       const handleSignUp = () => {
//         console.log('Sign Up clicked');
//         navigate('/register');
//       };


//   const StyledButton = styled(Button)(({ theme }) => ({
//     borderRadius: "99px",
//     padding: "12px 24px",
//     fontSize: "1rem",
//     fontWeight: "bold",
//     color: "#9b4d96",
//     transition: "0.5s",
//     textTransform: "none",
//   }));

//   return (
//     <>

//       {/* AppBar */}
//     <AppBar position="static" sx={{ backgroundColor: "transparent", boxShadow: "none" }}>
//       <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
//         <Typography variant="h3" sx={{ fontWeight: "bold", color: "#9b4d96" }}>
//           Vimoir
//         </Typography>
    
//         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//           <StyledButton onClick={handleSignIn}>
//           Sign In
//           </StyledButton>
//           <StyledButton  onClick={handleSignUp}>
//           Sign Up
//           </StyledButton>
//         </Box>
//       </Toolbar>
//     </AppBar>


// <Container sx={{ position: 'relative', textAlign: 'center', py: 1, overflow: 'hidden' }}>   
// <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1, pointerEvents: 'none' }}>
//   {/* Cuboid */}
//   <Box sx={{
//     position: 'absolute',
//     top: '2%',
//     left: '15%',
//     width: '900px',
//     height: '100px',
//     background: 'linear-gradient(135deg, #f3e5f5, #9b4d96, #f3e5f5)',
//     opacity: 0.4,
//     borderRadius: '8px',
//     transform: 'rotate(-5deg)',
//   }} />

// <Box sx={{
//     position: 'absolute',
//     top: '46%',
//     left: '8%',
//     width: '1000px',
//     height: '600px',
//     background: 'linear-gradient(135deg, #f3e5f5, #9b4d96, #f3e5f5)',
//     opacity: 0.4,
//     borderRadius: '8px',
//     transform: 'rotate(-5deg)',
//   }} />
//       </Box>
//       {/* Main Content (on top of cuboids) */}
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'relative', zIndex: 2 }}>
//         <Typography
//           variant="h2"
//           gutterBottom
//           sx={{
//             width: '90%',
//             padding: '20px',
//             fontWeight: 580,
//             fontSize: { xs: '1.875rem', md: '3rem', lg: '4.5rem' },
//             lineHeight: { xs: '2.25rem', md: '60px', lg: '80px' },
//           }}
//         >
//           Let the past play beautifully.vimoir.ai
//         </Typography>
//       </Box>
   
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'relative', zIndex: 2 }}>
//         <Typography gutterBottom sx={{ marginLeft: '90px', width: '70%', fontSize: '20px' }}>
//         vimoir.ai helps you convert photos into videos effortlessly. No editing skills required, just unleash your imagination.
//         </Typography>
//       </Box>

//             <Button
//                 color="inherit"
//                 variant="contained"
//                 size="small"
//                 onClick={() => {
//                     navigate('/login');
//                 }}
//                    sx={{
//                      background: ' #9b4d96', padding: '12px 24px', fontSize: '1.125rem', fontWeight: 'bold',   color: '#fff',   
//                      borderRadius: '9999px',transition: 'all 0.5s ease',marginBottom:'60px',
//                      '&:hover': {background: 'rgb(245, 81, 234)',},
//                      mt: 4,
//                      md: {mt: 6,px: 8,py: 4,fontSize: '1.25rem',
//                      },
//                    }}
//                  >
//                  Use Vimoir
//                  </Button>

//         <Grid container spacing={1}>
//           {sampleMedia.map((media, index) => (
//             <Grid item xs={12} sm={6} md={4} lg={4} key={index}>              
//             <Box
//                 sx={{
//                   width: '100%',
//                   height: 250,
//                   overflow: 'hidden',
//                   borderRadius: 2,
//                   position: 'relative',
//                   boxShadow: 2,
//                   cursor: 'pointer',
//                   '&:hover video': {
//                     transform: 'scale(1.02)',
//                     opacity: 1,
//                     transition: 'all 0.3s ease-in-out',
//                   },
//                 }}
//               >
//             {media.type === 'video' ? (
//             <video
//                 width="100%"
//                 height="100%"
//                 controls
//                 muted
//                 autoPlay
//                 loop
//                 style={{ borderRadius: '8px' }}
//             >
//                 <source src={media.src} type="video/mp4" />
//                 Your browser does not support the video tag.
//             </video>
//             ) : (
//             <img
//                 src={media.src}
//                 alt="Random"
//                 style={{ width: '100%', borderRadius: '8px' }}
//             />
//             )}
//               </Box>
//             </Grid>
//           ))}
//         </Grid>


//     <Box sx={{my: 6,px: 2,textAlign: 'left',}}>
//         <Typography
//         variant="h2"
//         gutterBottom
//         sx={{width: { xs: '100%', sm: '90%', md: '80%' },  mx: 'auto',textAlign: 'center',padding: '16px',fontWeight: 580,
//             fontSize: {xs: '1.5rem',md: '2.5rem',lg: '3.5rem'},
//             lineHeight: {xs: '2rem',md:'48px',lg: '64px' },
//         }}>
//         What is Vimoir?
//         </Typography>
//         <Typography variant="body1" paragraph >
//         Vimoir is an intuitive event video maker platform that lets you upload your photos and enter event details to automatically generate short, memorable videos—each linked to its own QR code for effortless sharing. It provides secure user authentication and robust photo/video management, while built‑in notifications and approval workflows ensure that only authorized viewers can access your content. Designed for both web and mobile, Vemoir delivers a seamless, responsive experience and leverages efficient backend processing for rapid video creation and secure cloud storage. All of this comes together in a professional, user‑friendly interface that requires no editing skills.
//         </Typography>
//     </Box>
//     <Box sx={{ 
//       // backgroundColor: '#fdfdfd',
//        py: 2}}>
//       <Container maxWidth="lg">
//     <Typography
//         variant="h6"
//         gutterBottom
//         sx={{width: { xs: '100%', sm: '90%', md: '80%' },  mx: 'auto',textAlign: 'center',padding: '1px',fontWeight: 580,
//             fontSize: {xs: '0.5rem',md: '1.5rem',lg: '2.5rem'},
//             lineHeight: {xs: '2rem',md:'48px',lg: '64px' },
//         }}>
//          How Vimoir Works?
//         </Typography>
//         <Typography variant="subtitle1" align="center" color="text.secondary">
//           Turn your memories into beautiful videos in just three simple steps.
//         </Typography>
   
//   <Box sx={{ position: 'relative', py: 8, px: 2, maxWidth: 1000, mx: 'auto' }}>
//   <Box
//       component="svg"
//       viewBox="0 0 600 100"
//       preserveAspectRatio="none"
//       sx={{position: 'absolute',top: 40,left: 0,width: '100%',height: 100,zIndex: 1,pointerEvents: 'none',}}>
//       {/* Downward curve (Step1 → Step2) */}
//       <path
//         d="M100,50 C150,0 250,0 300,50"
//         stroke="#9b4d96"
//         strokeWidth="2"
//         fill="none"
//         strokeDasharray="8,4"
//       />
//       {/* Upward curve (Step2 → Step3) */}
//       <path
//         d="M300,50 C350,100 450,100 500,50"
//         stroke="#9b4d96"
//         strokeWidth="2"
//         fill="none"
//         strokeDasharray="8,4"
//       />
//     </Box>

//     {/* The three steps */}
//     <Box sx={{display: 'flex',justifyContent: 'space-between',alignItems: 'flex-start',position: 'relative',zIndex: 2,}}>
//       {steps.map((step, idx) => (
//         <Box key={idx} sx={{ width: '30%', textAlign: 'center' }}>
//           {/* Step label */}
//           <Box
//             sx={{display: 'inline-block',px: 3,py: 3,border: '2px solid #9b4d96',borderRadius:'100%',bgcolor: 'background.paper',color: '#9b4d96',fontWeight: 'bold',
//             }}
//           >
//             {step.title}
//           </Box>

//           <Box sx={{width: 0,height: 20,mx: 'auto',mt: 1,}}/>
//             <Typography variant="h5" gutterBottom>
//             {step.heading}
//           </Typography>
//           <Typography
//             variant="body2"
//             sx={{ mt: 2, color: 'text.secondary', lineHeight: 1.5 }}
//           >
//             {step.desc}
//           </Typography>          
//         </Box>
//       ))}
//     </Box>
//     </Box>
//     </Container>
//     </Box>


//     <Box sx={{my: 6,px: 2,textAlign: 'left',marginTop:'-30px',}}>
//     <Typography
//         variant="h6"
//         gutterBottom
//         sx={{width: { xs: '100%', sm: '90%', md: '80%' },  mx: 'auto',textAlign: 'center',padding: '16px',fontWeight: 580,
//             fontSize: {xs: '0.5rem',md: '1.5rem',lg: '2.5rem'},
//             lineHeight: {xs: '2rem',md:'48px',lg: '64px' },
//         }}>
//        Visual Guides
//         </Typography>
//     </Box>


//     <Box sx={{ p: 4 ,marginTop:'-60px',}}>
//       {mediaGroups.map((group, index) => {
//         const totalImages = group.images.length;
//         return (
//           <Box
//             key={index}
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               mb: 8,
//               gap: 6,
//             }}
//             onMouseEnter={() => setHoveredIndex(index)}
//             onMouseLeave={() => setHoveredIndex(null)}
//           >
//             {/* Image Grid Box with Fixed Dimensions */}
//             <Box
//               sx={{
//                 width: 540,
//                 height: 300,
//                 backgroundColor: '#f9f9f9',
//                 borderRadius: 2,
//                 boxShadow: 1,
//                 overflow: 'hidden',
//               }}
//             >
//               <Grid container spacing={1} sx={{ height: '100%' }}>
//                 {group.images.map((img, i) => {
//                   const { xs, height } = getGridItemProps(totalImages);
//                   return (
//                     <Grid item xs={xs} key={i} sx={{ height }}>
//                       <CardMedia
//                         component="img"
//                         image={img}
//                         alt={`img-${i}`}
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           objectFit: 'cover',
//                           borderRadius: 1,
//                         }}
//                       />
//                     </Grid>
//                   );
//                 })}
//               </Grid>
//             </Box>

//             {/* Video or Image Preview */}
//             <CardMedia
//               component={hoveredIndex === index ? 'video' : 'img'}
//               src={hoveredIndex === index ? group.video : group.images[0]}
//               autoPlay={hoveredIndex === index}
//               muted
//               loop
//               alt={`preview-${index}`}
//               sx={{
//                 width: 500,
//                 height: 300,
//                 borderRadius: 2,
//                 boxShadow: 4,
//                 objectFit: 'cover',
//               }}
//             />
//           </Box>
//         );
//       })}
//     </Box>
//       </Container>
//     </>
//   );
// };

// export default WelcomePage;











import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import video1 from "./assests/video1.mp4";
import video2 from "./assests/video2.mp4";
import nature from './assests/nature.mp4';
import animal from './assests/animal.mp4';
import car from './assests/car.mp4';
import nature1 from './assests/nature1.jpg';
import nature2 from './assests/nature2.jpg';
import nature3 from './assests/nature3.jpg';
import nature4 from './assests/nature4.jpg';
import animal1 from './assests/animal1.jpg';
import animal2 from './assests/animal2.jpg';
import animal3 from './assests/animal3.jpg';
import animal4 from './assests/animal4.jpg';
import car1 from './assests/car1.jpg';
import car2 from './assests/car2.jpg';
import car3 from './assests/car3.jpg';
import car4 from './assests/car4.jpg';

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400;1,600&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --amber:       #C2823C;
    --amber-light: #E8A85A;
    --amber-pale:  #F5D8B0;
    --cream:       #FAF8F4;
    --ivory:       #FFFEFB;
    --paper:       #F5F1EA;
    --ink:         #1a1510;
    --ink-mid:     #4a3f30;
    --ink-light:   #8a7055;
    --border:      rgba(194,130,60,0.18);
  }

  html { scroll-behavior: smooth; }

  body {
    font-family: 'DM Sans', sans-serif;
    background: var(--cream);
    color: var(--ink);
    overflow-x: hidden;
    line-height: 1.6;
  }

  body::before {
    content: '';
    position: fixed; inset: 0;
    background:
      radial-gradient(ellipse 60% 50% at 8% 5%,  rgba(217,168,100,0.13) 0%, transparent 55%),
      radial-gradient(ellipse 50% 40% at 92% 95%, rgba(180,140,200,0.08) 0%, transparent 55%),
      radial-gradient(ellipse 70% 60% at 55% 40%, rgba(240,220,190,0.14) 0%, transparent 55%);
    pointer-events: none; z-index: 0;
  }

  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-thumb { background: rgba(194,130,60,0.3); border-radius: 2px; }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(28px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50%       { transform: translateY(-12px); }
  }
  @keyframes pulse {
    0%, 100% { opacity: 0.6; transform: scale(1); }
    50%       { opacity: 1; transform: scale(1.08); }
  }
  @keyframes marquee {
    from { transform: translateX(0); }
    to   { transform: translateX(-50%); }
  }

  /* ── NAV ── */
  .nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 100;
    background: rgba(250,248,244,0.9);
    backdrop-filter: blur(28px);
    border-bottom: 1px solid transparent;
    transition: all 0.3s ease;
  }
  .nav.scrolled {
    border-bottom-color: var(--border);
    box-shadow: 0 2px 32px rgba(100,70,30,0.1);
  }
  .nav-inner {
    max-width: 1360px; margin: 0 auto;
    padding: 0 40px; height: 72px;
    display: flex; align-items: center; justify-content: space-between;
  }
  .nav-logo { display: flex; align-items: center; gap: 11px; text-decoration: none; }
  .nav-logo-icon {
    width: 50px; height: 50px; border-radius: 12px;
    background: linear-gradient(135deg, var(--amber), var(--amber-light));
    display: flex; align-items: center; justify-content: center;
    font-size: 40px; color: #fff;
    box-shadow: 0 4px 16px rgba(194,130,60,0.4);
  }
  .nav-logo-text {
    font-family: 'Cormorant Garamond', serif;
    font-weight: 700; font-size: 4rem;
    color: var(--ink); letter-spacing: -0.01em; line-height: 1;
  }
  .nav-links { display: flex; align-items: center; gap: 4px; }
  .nav-link {
    font-weight: 500; font-size: 1.15rem;
    color: var(--ink-mid); text-decoration: none;
    padding: 9px 18px; border-radius: 50px;
    border: 1px solid transparent;
    transition: all 0.2s ease; cursor: pointer; background: none;
    font-family: 'DM Sans', sans-serif;
  }
  .nav-link:hover { color: var(--amber); background: rgba(194,130,60,0.08); border-color: rgba(194,130,60,0.22); }
  .btn-nav-cta {
    font-family: 'DM Sans', sans-serif; font-weight: 600; font-size: 0.95rem;
    color: #fff; background: linear-gradient(135deg, var(--amber), var(--amber-light));
    padding: 10px 26px; border-radius: 50px; border: none; cursor: pointer;
    box-shadow: 0 4px 18px rgba(194,130,60,0.38); transition: all 0.25s ease;
  }
  .btn-nav-cta:hover { transform: translateY(-1px); box-shadow: 0 8px 28px rgba(194,130,60,0.5); }

  /* ── HERO ── */
  .hero {
    min-height: 100vh;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    padding: 130px 40px 0;
    position: relative; z-index: 1; text-align: center;
  }
  .hero-eyebrow {
    display: inline-flex; align-items: center; gap: 9px;
    padding: 7px 18px; border-radius: 50px;
    background: rgba(194,130,60,0.1); border: 1px solid rgba(194,130,60,0.3);
    margin-bottom: 32px;
    animation: fadeUp 0.7s ease both;
  }
  .hero-eyebrow-dot {
    width: 7px; height: 7px; border-radius: 50%;
    background: var(--amber); animation: pulse 2s ease infinite;
  }
  .hero-eyebrow-text {
    font-size: 0.75rem; font-weight: 600;
    color: var(--amber); letter-spacing: 0.12em; text-transform: uppercase;
  }
  .hero-title {
    font-family: 'Cormorant Garamond', serif;
    font-weight: 10000; font-style: italic;
    font-size: clamp(4.8rem, 9.5vw, 8.5rem);
    line-height: 1.03; letter-spacing: -0.025em;
    color: var(--ink); max-width: 1000px;
    margin-bottom: 24px;
    animation: fadeUp 0.7s ease 0.1s both;
  }
  .hero-title span { color: var(--amber); }
  .hero-subtitle {
    font-size: clamp(1.55rem, 2vw, 1.35rem);
    color: var(--ink-light); font-weight: 300;
    max-width: 540px; line-height: 1.85; margin-bottom: 48px;
    animation: fadeUp 0.7s ease 0.2s both;
  }
  .hero-ctas {
    display: flex; align-items: center; gap: 16px; flex-wrap: wrap; justify-content: center;
    animation: fadeUp 0.7s ease 0.3s both; margin-bottom: 70px;
  }
  .btn-primary {
    font-family: 'DM Sans', sans-serif; font-weight: 600; font-size: 1.1rem;
    color: #fff; background: linear-gradient(135deg, var(--amber) 0%, var(--amber-light) 100%);
    padding: 17px 48px; border-radius: 50px; border: none; cursor: pointer;
    box-shadow: 0 6px 28px rgba(194,130,60,0.44);
    transition: all 0.3s cubic-bezier(0.34,1.56,0.64,1);
  }
  .btn-primary:hover { transform: translateY(-3px) scale(1.03); box-shadow: 0 16px 44px rgba(194,130,60,0.54); }
  .btn-secondary {
    font-family: 'DM Sans', sans-serif; font-weight: 500; font-size: 1.1rem;
    color: var(--ink-mid); background: var(--ivory);
    padding: 16px 40px; border-radius: 50px;
    border: 1px solid var(--border); cursor: pointer; transition: all 0.25s ease;
  }
  .btn-secondary:hover { background: var(--paper); border-color: rgba(194,130,60,0.45); color: var(--amber); }

  /* Hero stats */
  .hero-stats {
    display: flex; gap: 60px; justify-content: center; flex-wrap: wrap;
    animation: fadeUp 0.7s ease 0.4s both; margin-bottom: 0; padding-bottom: 72px;
  }
  .hero-stat { text-align: center; }
  .hero-stat-num {
    font-family: 'Cormorant Garamond', serif;
    font-weight: 700; font-size: 4.2rem; color: var(--amber); line-height: 1; margin-bottom: 6px;
  }
  .hero-stat-label {
    font-size: 1.15rem; color: var(--ink-light);
    letter-spacing: 0.12em; text-transform: uppercase; font-weight: 500;
  }
  .hero-stat-divider { width: 1px; background: var(--border); }
  .orb {
    position: absolute; border-radius: 50%; pointer-events: none;
    animation: float 8s ease-in-out infinite;
  }
  .orb-1 { width: 380px; height: 380px; top: 8%; right: 3%; background: radial-gradient(circle, rgba(194,130,60,0.12), transparent 70%); }
  .orb-2 { width: 260px; height: 260px; bottom: 15%; left: 2%; background: radial-gradient(circle, rgba(107,140,110,0.1), transparent 70%); animation-delay: -3s; }

  /* ── MARQUEE — NO GAP, FLUSH ── */
  .gallery-label-bar {
     border-top: 1px solid var(--border); border-bottom: 1px solid var(--border);
    padding: 14px 0; text-align: center; margin-bottom: 0;
  }
  .gallery-label {
    font-size: 0.73rem; font-weight: 600;
    color: var(--ink-light); letter-spacing: 0.16em; text-transform: uppercase;
  }
  .marquee-track:hover { animation-play-state: paused; }
.gallery-section {
  position: relative;
  z-index: 1;
  overflow: hidden;
  padding: 0 0 150px;
}

.marquee-track {
  display: flex;
  gap: 16px;
  align-items: center;
  width: max-content;
  animation: marquee 36s linear infinite;
}

.marquee-track:hover {
  animation-play-state: paused;
}

.marquee-item {
  flex-shrink: 0;
  width: 380px; /* required width */
  height: 380px; /* increased height */
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.35s ease;
}

.marquee-item:hover {
  transform: scale(1.02);
  z-index: 2;
}

.marquee-item img,
.marquee-item video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

@keyframes marquee {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}














  /* ── SECTIONS ── */
  .section {
    position: relative; z-index: 1;
    padding: 90px 40px;
    max-width: 1360px; margin: 0 auto;
  }
  .section-eyebrow { display: flex; align-items: center; gap: 12px; margin-bottom: 18px; }
  .section-eyebrow-line { width: 36px; height: 2px; background: linear-gradient(90deg, var(--amber), transparent); border-radius: 2px; }
  .section-eyebrow-text { font-size: 0.74rem; font-weight: 600; color: var(--amber); letter-spacing: 0.13em; text-transform: uppercase; }
  .section-title {
    font-family: 'Cormorant Garamond', serif;
    font-weight: 400; font-style: italic;
    font-size: clamp(2.6rem, 5vw, 4.2rem);
    line-height: 1.07; letter-spacing: -0.015em; color: var(--ink); margin-bottom: 20px;
  }
  .section-title span { color: var(--amber); }
  .section-desc { font-size: 1.1rem; color: var(--ink-light); font-weight: 300; line-height: 1.8; max-width: 600px; }

  /* ── ABOUT ── */
  .about-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .about-visual { position: relative; }
  .about-visual-main {
    width: 100%; aspect-ratio: 4/3; border-radius: 22px; overflow: hidden;
    border: 1px solid var(--border); box-shadow: 0 32px 80px rgba(100,70,30,0.18);
  }
  .about-visual-main img { width: 100%; height: 100%; object-fit: cover; display: block; }
  .about-visual-badge {
    position: absolute; bottom: -22px; right: -22px;
    background: var(--ivory); border: 1px solid var(--border);
    border-radius: 18px; padding: 18px 22px;
    box-shadow: 0 12px 40px rgba(100,70,30,0.14);
    display: flex; align-items: center; gap: 14px;
  }
  .about-badge-icon {
    width: 46px; height: 46px; border-radius: 12px;
    background: linear-gradient(135deg, var(--amber), var(--amber-light));
    display: flex; align-items: center; justify-content: center;
    font-size: 20px; color: #fff;
  }
  .about-badge-text-label { font-size: 0.72rem; color: var(--ink-light); font-weight: 500; margin-bottom: 3px; text-transform: uppercase; letter-spacing: 0.08em; }
  .about-badge-text-value { font-family: 'Cormorant Garamond', serif; font-weight: 600; font-size: 1.2rem; color: var(--ink); }
  .about-features { display: flex; flex-direction: column; gap: 16px; margin-top: 40px; }
  .about-feature {
    display: flex; gap: 18px; align-items: flex-start;
    padding: 20px 24px; border-radius: 16px;
    background: var(--ivory); border: 1px solid var(--border);
    transition: all 0.25s ease;
  }
  .about-feature:hover { transform: translateX(8px); border-color: rgba(194,130,60,0.38); box-shadow: 0 4px 20px rgba(194,130,60,0.1); }
  .about-feature-icon { width: 44px; height: 44px; border-radius: 12px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .about-feature-title { font-weight: 600; font-size: 1rem; color: var(--ink); margin-bottom: 5px; }
  .about-feature-desc { font-size: 0.9rem; color: var(--ink-light); line-height: 1.65; }

  /* ── HOW IT WORKS ── */
  .how-wrapper {
    position: relative; z-index: 1;
    background: var(--ivory); border-top: 1px solid var(--border); border-bottom: 1px solid var(--border);
    padding: 90px 40px;
  }
  .how-inner { max-width: 1360px; margin: 0 auto; }
  .how-header { text-align: center; margin-bottom: 72px; }
  .how-steps { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 0; position: relative; }
  .how-connector {
    position: absolute; top: 44px; left: calc(33.3% + 30px); right: calc(33.3% + 30px);
    height: 2px; background: linear-gradient(90deg, var(--amber), var(--amber-light), var(--amber));
  }
  .how-connector::before, .how-connector::after {
    content: ''; position: absolute; width: 9px; height: 9px;
    border-radius: 50%; background: var(--amber); top: 50%; transform: translateY(-50%);
  }
  .how-connector::before { left: 0; } .how-connector::after { right: 0; }
  .how-step { padding: 0 32px; text-align: center; }
  .how-step-num-wrap { display: flex; justify-content: center; margin-bottom: 28px; }
  .how-step-num {
    width: 88px; height: 88px; border-radius: 50%;
    border: 2px solid var(--border); background: var(--cream);
    display: flex; align-items: center; justify-content: center;
    font-family: 'Cormorant Garamond', serif; font-weight: 700; font-size: 1.8rem; color: var(--amber);
    position: relative; z-index: 1;
    box-shadow: 0 0 0 7px var(--ivory), 0 0 0 8px var(--border);
    transition: all 0.3s ease;
  }
  .how-step:hover .how-step-num {
    background: linear-gradient(135deg, var(--amber), var(--amber-light));
    color: #fff; border-color: var(--amber);
    box-shadow: 0 0 0 7px var(--ivory), 0 0 0 8px var(--amber), 0 10px 28px rgba(194,130,60,0.32);
  }
  .how-step-title { font-family: 'Cormorant Garamond', serif; font-weight: 600; font-size: 1.55rem; color: var(--ink); margin-bottom: 14px; }
  .how-step-desc { font-size: 0.95rem; color: var(--ink-light); line-height: 1.8; }

  /* ── VISUAL GUIDE ── */
  .guide-row {
    display: grid; grid-template-columns: 1fr auto 1fr;
    gap: 0; align-items: center; margin-bottom: 72px;
    opacity: 0; transform: translateY(22px);
    transition: opacity 0.65s ease, transform 0.65s ease;
  }
  .guide-row.visible { opacity: 1; transform: translateY(0); }
  .guide-arrow { display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 0 36px; }
  .guide-arrow-line { width: 2px; height: 70px; background: linear-gradient(180deg, transparent, var(--amber), transparent); }
  .guide-arrow-icon {
    width: 46px; height: 46px; border-radius: 50%;
    background: linear-gradient(135deg, var(--amber), var(--amber-light));
    display: flex; align-items: center; justify-content: center;
    color: #fff; font-size: 18px; box-shadow: 0 5px 18px rgba(194,130,60,0.42);
  }
  .guide-label { font-size: 0.73rem; color: var(--amber); font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase; }
  .guide-images-grid {
    display: grid; grid-template-columns: 1fr 1fr; gap: 6px;
    border-radius: 20px; overflow: hidden;
    border: 1px solid var(--border); box-shadow: 0 10px 40px rgba(100,70,30,0.12);
    aspect-ratio: 4/3;
  }
  .guide-img { width: 100%; height: 100%; object-fit: cover; display: block; }
  .guide-video-wrap {
    border-radius: 20px; overflow: hidden;
    border: 1px solid var(--border); box-shadow: 0 24px 80px rgba(100,70,30,0.2);
    position: relative; aspect-ratio: 4/3; cursor: pointer; background: #111;
  }
  .guide-video-wrap video { width: 100%; height: 100%; object-fit: cover; display: block; }
  .guide-video-overlay {
    position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
    background: rgba(26,21,16,0.32); transition: background 0.3s ease;
  }
  .guide-video-wrap:hover .guide-video-overlay { background: rgba(26,21,16,0.12); }
  .guide-play-btn {
    width: 62px; height: 62px; border-radius: 50%;
    background: rgba(255,255,255,0.92);
    display: flex; align-items: center; justify-content: center;
    font-size: 22px; padding-left: 4px;
    box-shadow: 0 6px 24px rgba(0,0,0,0.28); transition: transform 0.25s ease;
  }
  .guide-video-wrap:hover .guide-play-btn { transform: scale(1.12); }
  .guide-tag {
    position: absolute; top: 16px; left: 16px;
    background: rgba(250,248,244,0.92); backdrop-filter: blur(8px);
    border: 1px solid var(--border); border-radius: 50px;
    padding: 5px 14px; font-size: 0.75rem; font-weight: 600; color: var(--amber);
  }

  /* ── QUOTE ── */
  .quote-wrapper { position: relative; z-index: 1; padding: 90px 40px; }
  .quote-inner { max-width: 860px; margin: 0 auto; text-align: center; }
  .quote-mark {
    font-family: 'Cormorant Garamond', serif;
    font-size: 8rem; line-height: 0.55;
    color: rgba(194,130,60,0.18); display: block; margin-bottom: 20px;
  }
  .quote-text {
    font-family: 'Cormorant Garamond', serif; font-weight: 400; font-style: italic;
    font-size: clamp(1.7rem, 3.2vw, 2.6rem);
    color: var(--ink); line-height: 1.45; margin-bottom: 32px;
  }
  .quote-author { display: flex; align-items: center; justify-content: center; gap: 14px; }
  .quote-author-line { width: 28px; height: 1px; background: var(--border); }
  .quote-author-name { font-size: 0.85rem; color: var(--ink-light); letter-spacing: 0.07em; }

  /* ── CTA ── */
  .cta-wrapper {
    position: relative; z-index: 1; overflow: hidden;
    margin: 0 40px 90px; border-radius: 30px;
    background: linear-gradient(135deg, #1a1510 0%, #2d1f0a 50%, #1a1510 100%);
    padding: 110px 56px; text-align: center;
    border: 1px solid rgba(194,130,60,0.25); box-shadow: 0 32px 80px rgba(100,70,30,0.24);
  }
  .cta-glow {
    position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%);
    width: 700px; height: 360px;
    background: radial-gradient(ellipse, rgba(194,130,60,0.2), transparent 70%);
    pointer-events: none;
  }
  .cta-title {
    font-family: 'Cormorant Garamond', serif; font-weight: 400; font-style: italic;
    font-size: clamp(2.4rem, 5vw, 4.2rem);
    color: #FFFEFB; line-height: 1.1; margin-bottom: 20px; position: relative;
  }
  .cta-title span { color: var(--amber-light); }
  .cta-desc {
    font-size: 1.1rem; color: rgba(255,255,255,0.52); font-weight: 300;
    max-width: 460px; margin: 0 auto 48px; line-height: 1.75; position: relative;
  }
  .cta-buttons { display: flex; gap: 18px; justify-content: center; flex-wrap: wrap; position: relative; }
  .btn-cta-primary {
    font-family: 'DM Sans', sans-serif; font-weight: 600; font-size: 1.1rem;
    color: #fff; background: linear-gradient(135deg, var(--amber), var(--amber-light));
    padding: 18px 52px; border-radius: 50px; border: none; cursor: pointer;
    box-shadow: 0 8px 32px rgba(194,130,60,0.48); transition: all 0.3s ease;
  }
  .btn-cta-primary:hover { transform: translateY(-2px); box-shadow: 0 16px 48px rgba(194,130,60,0.62); }
  .btn-cta-secondary {
    font-family: 'DM Sans', sans-serif; font-weight: 500; font-size: 1.1rem;
    color: rgba(255,255,255,0.68); background: transparent;
    padding: 17px 40px; border-radius: 50px;
    border: 1px solid rgba(255,255,255,0.22); cursor: pointer; transition: all 0.25s ease;
  }
  .btn-cta-secondary:hover { border-color: rgba(255,255,255,0.45); color: #fff; background: rgba(255,255,255,0.07); }

  /* ── FOOTER ── */
  .footer { position: relative; z-index: 1; border-top: 1px solid var(--border); padding: 36px 40px; }
  .footer-inner {
    max-width: 1360px; margin: 0 auto;
    display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px;
  }
  .footer-copy { font-size: 0.85rem; color: var(--ink-light); }
  .footer-links { display: flex; gap: 28px; }
  .footer-link { font-size: 0.85rem; color: var(--ink-light); text-decoration: none; transition: color 0.2s; }
  .footer-link:hover { color: var(--amber); }

  /* ── RESPONSIVE ── */
  @media (max-width: 960px) {
    .about-grid { grid-template-columns: 1fr; gap: 48px; }
    .about-visual { display: none; }
    .how-steps { grid-template-columns: 1fr; gap: 48px; }
    .how-connector { display: none; }
    .guide-row { grid-template-columns: 1fr; }
    .guide-arrow { flex-direction: row; padding: 18px 0; }
    .guide-arrow-line { width: 70px; height: 2px; }
    .cta-wrapper { margin: 0 20px 70px; padding: 70px 28px; }
    .nav-inner { padding: 0 24px; }
    .hero { padding: 110px 24px 0; }
    .hero-stats { gap: 28px; }
    .section, .how-wrapper, .quote-wrapper, .footer { padding-left: 24px; padding-right: 24px; }
    .marquee-item { width: 280px; height: 190px; }
  }
`;

const mediaGroups = [
  { label: 'Nature',     images: [nature1, nature2, nature3, nature4], video: nature },
  { label: 'Wildlife',   images: [animal1, animal2, animal3, animal4], video: animal },
  { label: 'Automotive', images: [car1, car2, car3, car4],             video: car },
];

const features = [
  { icon: '🎬', color: 'rgba(194,130,60,0.12)', title: 'AI Video Generation',  desc: 'Upload photos, get a cinematic video automatically. Zero editing skills required.' },
  { icon: '🔐', color: 'rgba(107,140,110,0.12)', title: 'Private by Default',  desc: 'Every event is protected. Access only via your shared link or unique QR code.' },
  { icon: '📱', color: 'rgba(90,104,128,0.12)',  title: 'Instant Sharing',     desc: 'Share via email or SMS. Recipients watch instantly — no downloads, no logins.' },
];

const steps = [
  { num: '01', title: 'Sign Up & Sign In',  desc: 'Create your free Vimoir account in seconds to access your secure personal dashboard.' },
  { num: '02', title: 'Upload & Create',    desc: 'Name your event, upload your photos, and let our AI generate a beautiful video with a unique QR code automatically.' },
  { num: '03', title: 'Share Securely',     desc: 'Send your video via email or SMS. Recipients can watch instantly while you keep full control.' },
];

const marqueeItems = [
  { type: 'img',   src: nature1 }, { type: 'video', src: nature  },
  { type: 'img',   src: animal1 }, { type: 'video', src: animal  },
  { type: 'img',   src: car1    }, { type: 'video', src: car     },
  { type: 'img',   src: nature2 }, { type: 'img',   src: animal2 },
  { type: 'img',   src: car2    }, { type: 'img',   src: nature3 },
];
const doubledMarquee = [...marqueeItems, ...marqueeItems];

const WelcomePage = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled]       = useState(false);
  const [playingVideo, setPlayingVideo] = useState(null);
  const guideRefs = useRef([]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.18 }
    );
    guideRefs.current.forEach(el => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <>
      <style>{CSS}</style>

      {/* ── NAV ── */}
      <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
        <div className="nav-inner">
          <a className="nav-logo" href="/">
            <div className="nav-logo-icon">✦</div>
            <span className="nav-logo-text">vimoir</span>
          </a>
          <div className="nav-links">
            <a className="nav-link" href="#about">About</a>
            <a className="nav-link" href="#how">How it works</a>
            <a className="nav-link" href="#gallery">Gallery</a>
            <button className="nav-link" onClick={() => navigate('/login')}>Sign in</button>
            <button className="btn-nav-cta" onClick={() => navigate('/register')}>Get started</button>
          </div>
        </div>
      </nav>

      {/* ── HERO ── */}
      <section className="hero">
        <h1 className="hero-title">
          Let the past<br />
          <span>play beautifully.</span>
        </h1>

        <p className="hero-subtitle">
          Transform your photos into cinematic memories — no editing skills required.
          Just your imagination and your moments.
        </p>

        <div className="hero-ctas">
          <button className="btn-primary" onClick={() => navigate('/register')}>✦ Start for free</button>
          <button className="btn-secondary" onClick={() => navigate('/login')}>Sign in →</button>
        </div>

        <div className="hero-stats">
          <div className="hero-stat">
            <div className="hero-stat-num">∞</div>
            <div className="hero-stat-label">Memories</div>
          </div>
          <div className="hero-stat-divider" aria-hidden="true" />
          <div className="hero-stat">
            <div className="hero-stat-num">0</div>
            <div className="hero-stat-label">Editing Skills Needed</div>
          </div>
          <div className="hero-stat-divider" aria-hidden="true" />
          <div className="hero-stat">
            <div className="hero-stat-num">100%</div>
            <div className="hero-stat-label">Private &amp; Secure</div>
          </div>
        </div>
      </section>

      {/* ── MARQUEE — flush, no gap ── */}
      <section className="gallery-section" id="gallery">
        <div className="gallery-label-bar">
          <span className="gallery-label">Memories made with vimoir</span>
        </div>
        <div style={{ overflow: 'hidden', borderBottom: '1px solid rgba(194,130,60,0.18)' }}>
          <div className="marquee-track">
            {doubledMarquee.map((item, i) => (
              <div className="marquee-item" key={i}>
                {item.type === 'video' ? (
                  <video autoPlay muted loop playsInline>
                    <source src={item.src} type="video/mp4" />
                  </video>
                ) : (
                  <img src={item.src} alt="" loading="lazy" />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section className="section" id="about">
        <div className="about-grid">
          <div>
            <div className="section-eyebrow">
              <div className="section-eyebrow-line" />
              <span className="section-eyebrow-text">What is Vimoir</span>
            </div>
            <h2 className="section-title">Your photos,<br /><span>their story.</span></h2>
            <p className="section-desc">
              Vimoir is an intuitive event video maker that transforms your photos into
              short, beautiful cinematic videos — each secured with a unique QR code for
              effortless, private sharing. No editing. No technical knowledge. Just memories.
            </p>
            <div className="about-features">
              {features.map((f, i) => (
                <div className="about-feature" key={i}>
                  <div className="about-feature-icon" style={{ background: f.color }}>{f.icon}</div>
                  <div>
                    <div className="about-feature-title">{f.title}</div>
                    <div className="about-feature-desc">{f.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="about-visual">
            <div className="about-visual-main">
              <img src={nature1} alt="Example memory" />
            </div>
            <div className="about-visual-badge">
              <div className="about-badge-icon">🎬</div>
              <div>
                <div className="about-badge-text-label">AI Generated</div>
                <div className="about-badge-text-value">Instant video</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <div className="how-wrapper" id="how">
        <div className="how-inner">
          <div className="how-header">
            <div className="section-eyebrow" style={{ justifyContent: 'center' }}>
              <div className="section-eyebrow-line" />
              <span className="section-eyebrow-text">How it works</span>
              <div className="section-eyebrow-line" style={{ transform: 'scaleX(-1)' }} />
            </div>
            <h2 className="section-title" style={{ textAlign: 'center' }}>
              Three steps to your<br /><span>perfect memory</span>
            </h2>
          </div>
          <div className="how-steps">
            <div className="how-connector" aria-hidden="true" />
            {steps.map((s, i) => (
              <div className="how-step" key={i}>
                <div className="how-step-num-wrap">
                  <div className="how-step-num">{s.num}</div>
                </div>
                <div className="how-step-title">{s.title}</div>
                <p className="how-step-desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── VISUAL GUIDE ── */}
      <section className="section">
        <div style={{ marginBottom: 64 }}>
          <div className="section-eyebrow">
            <div className="section-eyebrow-line" />
            <span className="section-eyebrow-text">Visual guide</span>
          </div>
          <h2 className="section-title">Photos in,<br /><span>magic out.</span></h2>
          <p className="section-desc">
            See how Vimoir transforms a collection of everyday photos into a cinematic experience in seconds.
          </p>
        </div>

        {mediaGroups.map((group, i) => (
          <div
            key={i}
            className="guide-row"
            ref={el => guideRefs.current[i] = el}
            style={{ transitionDelay: `${i * 0.1}s` }}
          >
            <div className="guide-col">
              <div className="guide-images-grid">
                {group.images.map((img, j) => (
                  <img key={j} className="guide-img" src={img} alt={`${group.label} ${j + 1}`} loading="lazy" />
                ))}
              </div>
            </div>
            <div className="guide-arrow">
              <div className="guide-arrow-line" />
              <div className="guide-arrow-icon">✦</div>
              <span className="guide-label">AI</span>
              <div className="guide-arrow-line" />
            </div>
            <div className="guide-col">
              <div
                className="guide-video-wrap"
                onClick={() => {
                  const vid = document.getElementById(`guide-vid-${i}`);
                  if (vid) {
                    if (vid.paused) { vid.play(); setPlayingVideo(i); }
                    else            { vid.pause(); setPlayingVideo(null); }
                  }
                }}
              >
                <video id={`guide-vid-${i}`} src={group.video} loop muted playsInline>
                  <source src={group.video} type="video/mp4" />
                </video>
                <div className="guide-video-overlay">
                  {playingVideo !== i && <div className="guide-play-btn">▶</div>}
                </div>
                <div className="guide-tag">{group.label}</div>
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* ── QUOTE ── */}
      <div className="quote-wrapper">
        <div className="quote-inner">
          <span className="quote-mark">"</span>
          <p className="quote-text">
            The best way to preserve a moment is to let it play again and again,
            exactly as it was meant to be felt.
          </p>
          <div className="quote-author">
            <div className="quote-author-line" />
            <span className="quote-author-name">The Vimoir philosophy</span>
            <div className="quote-author-line" />
          </div>
        </div>
      </div>

      {/* ── CTA ── */}
      <div className="cta-wrapper">
        <div className="cta-glow" aria-hidden="true" />
        <h2 className="cta-title">Your memories deserve<br />to <span>live beautifully.</span></h2>
        <p className="cta-desc">
          Join thousands of people turning their photos into cinematic memories with Vimoir.
        </p>
        <div className="cta-buttons">
          <button className="btn-cta-primary" onClick={() => navigate('/register')}>✦ Create your first memory</button>
          <button className="btn-cta-secondary" onClick={() => navigate('/login')}>Already have an account →</button>
        </div>
      </div>

      {/* ── FOOTER ── */}
      <footer className="footer">
        <div className="footer-inner">
          <span className="footer-copy">© {new Date().getFullYear()} vimoir — made with care</span>
          <nav className="footer-links">
            <a className="footer-link" href="#">Privacy</a>
            <a className="footer-link" href="#">Terms</a>
            <a className="footer-link" href="#">Contact</a>
          </nav>
        </div>
      </footer>
    </>
  );
};

export default WelcomePage;